import React, { useState } from "react";
import { Popover, Badge, Flex } from "antd";
import { SketchPicker, ColorResult } from "react-color";
import { ColorPickerProps } from "../../types";

const ColorPicker: React.FC<ColorPickerProps> = ({ title, icon, onChange }) => {
  const [hex, setHex] = useState("#fff");

  const handleColorChange = (color: ColorResult) => {
    setHex(color.hex);
    onChange(color.hex);
  };

  const content = <SketchPicker color={hex} onChange={handleColorChange} />;

  return (
    <Popover content={content} title={title} trigger="click">
      <Flex style={{ height: 16 }}>
        <Badge dot style={{ backgroundColor: hex }}>
          {icon}
        </Badge>
      </Flex>
    </Popover>
  );
};

export default ColorPicker;
